import { httpGet } from '../../../../components/utils';
import { useCallback, useEffect, useState } from 'react';
import { HttpResponse } from '../../../../api/types/Http';
import { ReportSettings } from '../types/RiskReport';

interface ReportFileData {
    riskReportFileName?: string;
    riskReportFileDate?: string;
    insuranceFileName?: string;
    insuranceFileDate?: string;
    reportSettings?: ReportSettings;
    scheduledRiskReportFileName?: string;
}

const useGetReportFilesData = () => {
    const [data, setData] = useState<ReportFileData>();
    const [isFetching, setIsFetching] = useState(false);
    const [error, setError] = useState<string>();

    const getReportFilesData = useCallback(async () => {
        setIsFetching(true);
        setError(undefined);

        try {
            const response = (await httpGet('/insights/reportFiles')) as unknown as HttpResponse<ReportFileData>;

            setData(response.data);
        } catch (err) {
            setError('Failed to get report files data');
        }

        setIsFetching(false);
    }, []);

    useEffect(() => {
        getReportFilesData();
    }, [getReportFilesData]);

    return { data, isFetching, error, refreshData: getReportFilesData };
};

export default useGetReportFilesData;
